import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AddDeleteUpadate, fetchPostData } from '@/Components/hooks/Api';
import { Comman_changeArrayFormat, Comman_changeArrayFormatBasicInfowithoutcode, Comman_changeArrayFormatBasicInfo, threeColVictimOffenseArray, offenseArray, AssaultInjuryComArrayFormat, threeColArray, threeColVictimInjuryArray, threeColArrayWithCode } from '@/Components/Common/ChangeArrayFormat';
import { toastifySuccess } from '@/Components/Common/AlertMsg';
import { AgencyContext } from 'Context/Agency';
import { components } from "react-select";
import SelectBox from '@/Components/Common/SelectBox';
import { get_LocalStoreData } from '@/redux/api';
import { Decrypt_Id_Name, isLockOrRestrictModule } from '@/Components/Common/Utility';
import { useDispatch, useSelector } from 'react-redux';
import NameListing from '@/Components/Pages/ShowAllList/NameListing';
import { get_ScreenPermissions_Data } from '@/redux/actions/IncidentAction';
import ListModal from '@/Components/Pages/Utility/ListManagementModel/ListModal';

const Home = (props) => {

  const { ListData, DecNameID, DecMasterNameID, DecIncID } = props
  const { setOffenderCount } = useContext(AgencyContext);

  const dispatch = useDispatch();
  const localStoreData = useSelector((state) => state.Agency.localStoreData);
  const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
  const [typeOfSecurityEditVal, setTypeOfSecurityEditVal] = useState();

  const [offenderOffenseDrp, setOffenderOffenseDrp] = useState();
  const [offenderAssaultDrp, setOffenderAssaultDrp] = useState();
  const [value, setValue] = useState()
  const [nameID, setNameID] = useState();
  const [loginPinID, setLoginPinID,] = useState('');
  const [loginAgencyID, setLoginAgencyID] = useState('');
  const [incidentID, setIncidentID] = useState('');
  const [assaultEditVal, setAssaultEditVal] = useState();
  const [injuryTypeEditVal, setInjuryTypeEditVal] = useState();
  const [injuryTypeDrp, setInjuryTypeDrp] = useState();
  const [propertyDrp, setPropertyDrp] = useState();
  const [propertyEditVal, setPropertyEditVal] = useState();

  // New dropdown states for Offender Using, Bias Motivation, and Weapon Used
  const [crimeOffenderUseDrp, setCrimeOffenderUseDrp] = useState([]);
  const [crimeBiasCategoryDrp, setCrimeBiasCategoryDrp] = useState([]);
  const [weaponDrp, setWeaponDrp] = useState([]);
  const [weaponID, setWeaponID] = useState([]);
  const [weaponIDEditVal, setWeaponIDEditVal] = useState([]);
  const [openPage, setOpenPage] = useState('');
  const [offenderUsing, setOffenderUsing] = useState([]);
  const [offenderUsingEditVal, setOffenderUsingEditVal] = useState([]);
  const [biasMotivation, setBiasMotivation] = useState([]);
  const [biasMotivationEditVal, setBiasMotivationEditVal] = useState([]);
  //ids
  const [offenderOffenseID, setOffenderOffenseID] = useState();
  const [offenderAssaultID, setOffenderAssaultID] = useState();
  const [offenderInjuryID, setOffenderInjuryID] = useState();
  const [offenderPropertyID, setOffenderPropertyID] = useState();

  const MultiValue = props => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );

  useEffect(() => {
    if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
      if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
    }
  }, []);

  useEffect(() => {
    if (localStoreData) {
      setLoginAgencyID(localStoreData?.AgencyID); setLoginPinID(localStoreData?.PINID);
      dispatch(get_ScreenPermissions_Data("N058", localStoreData?.AgencyID, localStoreData?.PINID));
      get_Weapon_DropDown(localStoreData?.AgencyID);
      getCrimeBiasCategoryDrpVal(localStoreData?.AgencyID);
      getCrimeOffenderUseDrpVal(localStoreData?.AgencyID);
    }
  }, [localStoreData]);


  useEffect(() => {
    if (DecNameID) {
      setNameID(DecNameID);
      setIncidentID(DecIncID);
    }
  }, [DecNameID, loginPinID,]);

  useEffect(() => {
    if (DecNameID && DecMasterNameID) {
      setValue({ ...value, 'NameID': DecNameID, 'CreatedByUserFK': loginPinID, })
    }
  }, [DecNameID, DecMasterNameID, loginPinID]);

  useEffect(() => {
    if (nameID) { get_Offense_Data(nameID); get_InjuryType_Data(nameID); get_Offender_Assault_Data(DecNameID); get_Offender_Property_Data(nameID); get_Offender_Using_Data(nameID); get_BiasMotivation_Data(nameID); get_WeaponUsed_Data(nameID); }
  }, [nameID])

  // Refresh offender using data when dropdown options are loaded to update labels
  useEffect(() => {
    if (nameID && crimeOffenderUseDrp?.length > 0) {
      get_Offender_Using_Data();
    }
  }, [crimeOffenderUseDrp, nameID])

  // Refresh bias motivation data when dropdown options are loaded to update labels
  useEffect(() => {
    if (nameID && crimeBiasCategoryDrp?.length > 0) {
      get_BiasMotivation_Data();
    }
  }, [crimeBiasCategoryDrp, nameID])

  // Refresh weapon used data when dropdown options are loaded to update labels
  useEffect(() => {
    if (nameID && weaponDrp?.length > 0) {
      get_WeaponUsed_Data();
    }
  }, [weaponDrp, nameID])

  // offence
  useEffect(() => {
    if (typeOfSecurityEditVal) { setOffenderOffenseID(typeOfSecurityEditVal) }
  }, [typeOfSecurityEditVal])

  useEffect(() => {
    if (assaultEditVal) { setOffenderAssaultID(assaultEditVal) }
  }, [assaultEditVal])

  useEffect(() => {
    if (injuryTypeEditVal) { setOffenderInjuryID(injuryTypeEditVal) }
  }, [injuryTypeEditVal])

  useEffect(() => {
    if (propertyEditVal) { setOffenderPropertyID(propertyEditVal) }
  }, [propertyEditVal])

  useEffect(() => {
    const isAnyArrayEmpty = (Array.isArray(offenderOffenseID) && offenderOffenseID.length === 0) && (Array.isArray(offenderAssaultID) && offenderAssaultID.length === 0) && (Array.isArray(offenderInjuryID) && offenderInjuryID.length === 0) &&
      (Array.isArray(offenderPropertyID) && offenderPropertyID.length === 0);
    if (isAnyArrayEmpty) {
      setOffenderCount(false);
    } else {
      setOffenderCount(true);
    }
  }, [offenderOffenseID, offenderAssaultID, offenderInjuryID, offenderPropertyID]);


  useEffect(() => {
    if (incidentID) {
      get_Data_Offense_Drp(incidentID, nameID);
      get_Offender_Assault_Drp(incidentID, nameID);
      get_Data_InjuryType_Drp(incidentID, nameID);
      get_Offender_Property_Drp(incidentID, nameID);
    }
  }, [nameID, incidentID, loginAgencyID])

  const get_Offense_Data = () => {
    const val = { 'NameID': nameID, }
    fetchPostData('OffenderOffense/GetData_OffenderOffense', val).then((res) => {
      if (res) {
        const offence360 = res.filter((item) => item?.FBICode === '13A');
        setTypeOfSecurityEditVal(offenseArray(res, 'OffenderOffenseID', 'OffenseID', 'NameID', 'VictimID', 'Offense_Description', 'PretendToBeID'));
      } else {
        setTypeOfSecurityEditVal([]);
      }
    })
  }

  const get_InjuryType_Data = () => {
    const val = { 'NameID': nameID, }
    fetchPostData('OffenderInjury/GetData_OffenderInjury', val).then((res) => {
      if (res) {
        setInjuryTypeEditVal(AssaultInjuryComArrayFormat(res, 'InjuryID', 'NameID', 'PretendToBeID', 'OffenderInjuryID', 'Injury_Description'));
      } else {
        setInjuryTypeEditVal([]);
      }
    })
  }

  const get_Offender_Assault_Data = () => {
    const val = { 'NameID': nameID, }
    fetchPostData('OffenderAssault/GetData_OffenderAssault', val).then((res) => {
      if (res) {
        setAssaultEditVal(AssaultInjuryComArrayFormat(res, 'OffenderAssaultID', 'NameID', 'PretendToBeID', 'AssaultID', 'Assault_Description'));
      } else {
        setAssaultEditVal([]);
      }
    })
  }

  const get_Offender_Property_Data = () => {
    const val = { 'NameID': nameID, }
    fetchPostData('OffenderProperty/GetData_OffenderProperty', val).then((res) => {
      if (res) {
        setPropertyEditVal(Comman_changeArrayFormatBasicInfowithoutcode(res, 'OffenderPropertyID', 'NameID', 'PretendToBeID', 'PropertyID', 'Description'));
      } else {
        setPropertyEditVal([]);
      }
    })
  }

  const get_Offender_Using_Data = () => {
    const val = { 'NameID': nameID, }
    fetchPostData('OffenderSuspactedOfUsing/GetData_OffenderSuspactedOfUsing', val).then((res) => {
      if (res) {
        // Format data: value should be SuspactedOfUsingID (to match dropdown), id should be OffenderSuspactedOfUsingID (for delete)
        const formattedData = res?.map((item) => {
          // Find matching option from dropdown to get the label
          const matchingOption = crimeOffenderUseDrp?.find(opt => opt.value === item.SuspactedOfUsingID);
          return {
            value: item.SuspactedOfUsingID,
            label: matchingOption?.label || item.Description || '',
            id: item.OffenderSuspactedOfUsingID
          };
        }) || [];
        setOffenderUsingEditVal(formattedData);
        setOffenderUsing(formattedData);
      } else {
        setOffenderUsingEditVal([]);
        setOffenderUsing([]);
      }
    })
  }

  const get_BiasMotivation_Data = () => {
    const val = { 'NameID': nameID, }
    fetchPostData('OffenderBiasMotivation/GetData_OffenderBiasMotivation', val).then((res) => {
      if (res) {
        // Format data: value should be BiasMotivationID (to match dropdown), id should be OffenderBiasMotivationID (for delete)
        const formattedData = res?.map((item) => {
          // Find matching option from dropdown to get the label
          const matchingOption = crimeBiasCategoryDrp?.find(opt => opt.value === item.BiasMotivationID);
          return {
            value: item.BiasMotivationID,
            label: matchingOption?.label || item.Description || '',
            id: item.OffenderBiasMotivationID
          };
        }) || [];
        setBiasMotivationEditVal(formattedData);
        setBiasMotivation(formattedData);
      } else {
        setBiasMotivationEditVal([]);
        setBiasMotivation([]);
      }
    })
  }

  const get_WeaponUsed_Data = () => {
    const val = { 'NameID': nameID, }
    fetchPostData('OffenderWeaponUsed/GetData_OffenderWeaponUsed', val).then((res) => {
      if (res) {
        // Format data: value should be WeaponUsedID (to match dropdown), id should be OffenderWeaponUsedID (for delete)
        const formattedData = res?.map((item) => {
          // Find matching option from dropdown to get the label
          const matchingOption = weaponDrp?.find(opt => opt.value === item.WeaponUsedID);
          return {
            value: item.WeaponUsedID,
            label: matchingOption?.label || item.Description || '',
            id: item.OffenderWeaponUsedID
          };
        }) || [];
        setWeaponIDEditVal(formattedData);
        setWeaponID(formattedData);
      } else {
        setWeaponIDEditVal([]);
        setWeaponID([]);
      }
    })
  }

  const get_Data_Offense_Drp = (incidentID, nameID) => {
    const val = { 'NameID': nameID, 'IncidentId': incidentID, }
    fetchPostData('OffenderOffense/GetData_InsertOffenderOffense', val).then((data) => {
      if (data) {
        setOffenderOffenseDrp(threeColVictimOffenseArray(data, 'CrimeID', 'Offense_Description', 'FBICode'))
      } else {
        setOffenderOffenseDrp([])
      }
    })
  }

  const get_Data_InjuryType_Drp = (incidentID, nameID) => {
    const val = { 'NameID': nameID, 'IncidentId': incidentID, }
    fetchPostData('OffenderInjury/GetData_InsertOffenderInjury', val).then((data) => {
      if (data) {

        setInjuryTypeDrp(threeColVictimInjuryArray(data, 'VictimInjuryID', 'Description', 'InjuryCode'))
      } else {
        setInjuryTypeDrp([])
      }
    })
  }

  const get_Offender_Assault_Drp = (incidentID, nameID) => {
    const val = { 'NameID': nameID, 'IncidentId': incidentID, }
    fetchPostData('OffenderAssault/GetData_InsertOffenderAssault', val).then((data) => {
      if (data) {
        setOffenderAssaultDrp(Comman_changeArrayFormat(data, 'AssaultTypeID', 'Description'))
      } else {
        setOffenderAssaultDrp([])
      }
    })
  }

  const get_Offender_Property_Drp = (incidentID, nameID) => {
    const val = { 'NameID': nameID, 'IncidentId': incidentID, }
    fetchPostData('OffenderProperty/GetData_InsertOffenderProperty', val).then((data) => {
      if (data) {
        setPropertyDrp(threeColArray(data, 'PropertyID', 'Description'))
      } else {
        setPropertyDrp([])
      }
    })
  }

  // API functions for the three new dropdowns
  const getCrimeOffenderUseDrpVal = (loginAgencyID) => {
    const val = { AgencyID: loginAgencyID, }
    fetchPostData('CrimeOffenderUse/GetDataDropDown_CrimeOffenderUse', val).then((data) => {
      if (data) {
        setCrimeOffenderUseDrp(threeColArrayWithCode(data, 'OffenderUseID', 'Description', 'OffenderUseCode'))
      } else {
        setCrimeOffenderUseDrp([]);
      }
    })
  }

  const getCrimeBiasCategoryDrpVal = (loginAgencyID) => {
    const val = { AgencyID: loginAgencyID, }
    fetchPostData('CrimeBias/GetDataDropDown_CrimeBias', val).then((data) => {
      if (data) {

        setCrimeBiasCategoryDrp(threeColArrayWithCode(data, 'BiasID', 'Description', 'BiasCode'))
      } else {
        setCrimeBiasCategoryDrp([]);
      }
    })
  }

  const get_Weapon_DropDown = (loginAgencyID) => {
    const val = { 'AgencyID': loginAgencyID, }
    fetchPostData('OffenseWeapon/GetData_InsertOffenseWeapon', val).then((data) => {
      if (data) {

        setWeaponDrp(threeColArrayWithCode(data, 'WeaponID', 'Description', 'WeaponCode'));
      } else {
        setWeaponDrp([])
      }
    })
  }

  const AssaultTypeChange = (multiSelected) => {
    setOffenderAssaultID(multiSelected)
    const len = multiSelected.length - 1
    if (multiSelected?.length < assaultEditVal?.length) {
      let missing = null;
      let i = assaultEditVal.length;
      while (i) {
        missing = (~multiSelected.indexOf(assaultEditVal[--i])) ? missing : assaultEditVal[i];
      }
      DelSertBasicInfo(missing.value, 'OffenderAssaultID', 'OffenderAssault/DeleteOffenderAssault')

    } else {
      setOffenderCount(true);
      InSertBasicInfo(multiSelected[len].value, 'AssaultID', 'OffenderAssault/InsertOffenderAssault')
    }
  }

  const InjuryTypeChange = (multiSelected) => {

    setOffenderInjuryID(multiSelected)
    const len = multiSelected.length - 1
    if (multiSelected?.length < injuryTypeEditVal?.length) {
      let missing = null;
      let i = injuryTypeEditVal.length;
      while (i) {
        missing = (~multiSelected.indexOf(injuryTypeEditVal[--i])) ? missing : injuryTypeEditVal[i];
      }
      DelSertBasicInfo(missing.id, 'OffenderInjuryID', 'OffenderInjury/DeleteOffenderInjury')

    } else {
      setOffenderCount(true);
      InSertBasicInfo(multiSelected[len].value, 'InjuryID', 'OffenderInjury/InsertOffenderInjury')
    }
  }

  const PropertyChange = (multiSelected) => {
    setOffenderPropertyID(multiSelected)
    const len = multiSelected.length - 1
    if (multiSelected?.length < propertyEditVal?.length) {
      let missing = null;
      let i = propertyEditVal.length;
      while (i) {
        missing = (~multiSelected.indexOf(propertyEditVal[--i])) ? missing : propertyEditVal[i];
      }
      DelSertBasicInfo(missing.value, 'OffenderPropertyID', 'OffenderProperty/Delete_OffenderProperty')

    } else {
      setOffenderCount(true);
      InSertBasicInfo(multiSelected[len].value, 'PropertyID', 'OffenderProperty/Insert_OffenderProperty')
    }
  }

  const OffenderUsingChange = (multiSelected) => {
    setOffenderUsing(multiSelected)
    const len = multiSelected.length - 1
    if (multiSelected?.length < offenderUsingEditVal?.length) {
      // Find the missing item by comparing values
      let missing = null;
      const selectedValues = multiSelected.map(item => item.value);
      for (let i = 0; i < offenderUsingEditVal.length; i++) {
        if (!selectedValues.includes(offenderUsingEditVal[i].value)) {
          missing = offenderUsingEditVal[i];
          break;
        }
      }
      if (missing) {
        // Delete API call
        const val = {
          'OffenderSuspactedOfUsingID': missing.id,
          'DeletedByUserFK': loginPinID,
        }
        AddDeleteUpadate('OffenderSuspactedOfUsing/DeleteOffenderSuspactedOfUsing', val).then((res) => {
          if (res) {
            const parsedData = JSON.parse(res.data);
            const message = parsedData.Table[0].Message;
            toastifySuccess(message);
            get_Offender_Using_Data();
          } else {
            console.warn("Something Wrong");
          }
        })
      }
    } else if (multiSelected?.length > offenderUsingEditVal?.length) {
      // Insert API call
      const val = {
        'NameID': nameID,
        'SuspactedOfUsingID': multiSelected[len].value,
        'CreatedByUserFK': loginPinID,
      }
      AddDeleteUpadate('OffenderSuspactedOfUsing/InsertOffenderSuspactedOfUsing', val).then((res) => {
        if (res) {
          const parsedData = JSON.parse(res.data);
          const message = parsedData.Table[0].Message;
          toastifySuccess(message);
          get_Offender_Using_Data();
        } else {
          console.warn("Something Wrong");
        }
      })
    }
  }

  const BiasMotivationChange = (multiSelected) => {
    setBiasMotivation(multiSelected)
    const len = multiSelected.length - 1
    if (multiSelected?.length < biasMotivationEditVal?.length) {
      // Find the missing item by comparing values
      let missing = null;
      const selectedValues = multiSelected.map(item => item.value);
      for (let i = 0; i < biasMotivationEditVal.length; i++) {
        if (!selectedValues.includes(biasMotivationEditVal[i].value)) {
          missing = biasMotivationEditVal[i];
          break;
        }
      }
      if (missing) {
        // Delete API call
        const val = {
          'IsActive': '0',
          'OffenderBiasMotivationID': missing.id,
          'DeletedByUserFK': loginPinID,
        }
        AddDeleteUpadate('OffenderBiasMotivation/DeleteOffenderBiasMotivation', val).then((res) => {
          if (res) {
            const parsedData = JSON.parse(res.data);
            const message = parsedData.Table[0].Message;
            toastifySuccess(message);
            get_BiasMotivation_Data();
          } else {
            console.warn("Something Wrong");
          }
        })
      }
    } else if (multiSelected?.length > biasMotivationEditVal?.length) {
      // Insert API call
      const val = {
        'NameID': nameID,
        'BiasMotivationID': multiSelected[len].value,
        'CreatedByUserFK': loginPinID,
      }
      AddDeleteUpadate('OffenderBiasMotivation/InsertOffenderBiasMotivation', val).then((res) => {
        if (res) {
          const parsedData = JSON.parse(res.data);
          const message = parsedData.Table[0].Message;
          toastifySuccess(message);
          get_BiasMotivation_Data();
        } else {
          console.warn("Something Wrong");
        }
      })
    }
  }

  const WeaponUsedChange = (multiSelected) => {
    setWeaponID(multiSelected)
    const len = multiSelected.length - 1
    if (multiSelected?.length < weaponIDEditVal?.length) {
      // Find the missing item by comparing values
      let missing = null;
      const selectedValues = multiSelected.map(item => item.value);
      for (let i = 0; i < weaponIDEditVal.length; i++) {
        if (!selectedValues.includes(weaponIDEditVal[i].value)) {
          missing = weaponIDEditVal[i];
          break;
        }
      }
      if (missing) {
        // Delete API call
        const val = {
          'OffenderWeaponUsedID': missing.id,
          'DeletedByUserFK': loginPinID,
        }
        AddDeleteUpadate('OffenderWeaponUsed/DeleteOffenderWeaponUsed', val).then((res) => {
          if (res) {
            const parsedData = JSON.parse(res.data);
            const message = parsedData.Table[0].Message;
            toastifySuccess(message);
            get_WeaponUsed_Data();
          } else {
            console.warn("Something Wrong");
          }
        })
      }
    } else if (multiSelected?.length > weaponIDEditVal?.length) {
      // Insert API call
      const val = {
        'NameID': nameID,
        'WeaponUsedID': multiSelected[len].value,
        'CreatedByUserFK': loginPinID,
      }
      AddDeleteUpadate('OffenderWeaponUsed/InsertOffenderWeaponUsed', val).then((res) => {
        if (res) {
          const parsedData = JSON.parse(res.data);
          const message = parsedData.Table[0].Message;
          toastifySuccess(message);
          get_WeaponUsed_Data();
        } else {
          console.warn("Something Wrong");
        }
      })
    }
  }

  const InSertBasicInfo = (id, col1, url) => {
    const val = {
      'NameID': nameID,
      [col1]: id,
      'CreatedByUserFK': loginPinID,
    }
    AddDeleteUpadate(url, val).then((res) => {
      if (res) {
        const parsedData = JSON.parse(res.data);
        const message = parsedData.Table[0].Message;
        toastifySuccess(message);

        col1 === 'OffenseID' && get_Offense_Data(); get_Data_Offense_Drp(incidentID, nameID);
        col1 === 'PropertyID' && get_Offender_Property_Data(); get_Offender_Property_Drp(incidentID, nameID);
        col1 === 'InjuryID' && get_InjuryType_Data();
        col1 === 'AssaultID' && get_Offender_Assault_Data(); get_Offender_Assault_Drp(incidentID, nameID);
      } else {
        console.warn("Somthing Wrong");
      }
    })
  }

  const DelSertBasicInfo = (OffenderOffenseID, col1, url) => {
    const val = {
      [col1]: OffenderOffenseID,
      'DeletedByUserFK': loginPinID,
    }
    AddDeleteUpadate(url, val).then((res) => {
      if (res) {
        const parsedData = JSON.parse(res.data);
        const message = parsedData.Table[0].Message;
        toastifySuccess(message);

        col1 === 'OffenderOffenseID' && get_Offense_Data(); get_Data_Offense_Drp(incidentID, nameID);
        col1 === 'OffenderPropertyID' && get_Offender_Property_Data(); get_Offender_Property_Drp(incidentID, nameID);
        col1 === 'OffenderInjuryID' && get_InjuryType_Data()
        col1 === 'OffenderAssaultID' && get_Offender_Assault_Data(); get_Offender_Assault_Drp(incidentID, nameID);
      } else {
        console.warn("Somthing Wrong");
      }
    })
  }

  const customStylesWithOutColor = {
    control: base => ({
      ...base,
      minHeight: 60,
      fontSize: 14,
      margintop: 2,
      boxShadow: 0,
    }),
  };

  return (
    <>
      <NameListing {... { ListData }} />
      <div className="col-12">
        <div className="row">
          <div className="col-12 col-md-12 col-lg-12">
            <div className="row">
              <div className="col-2 col-md-2 col-lg-2 mt-3">
                <span style={{ lineHeight: 1.1 }} data-toggle="modal" onClick={() => setOpenPage("Assault Type")} data-target="#ListModel" className="new-link  ">
                  Assault Type
                </span>
              </div>
              <div className="col-4 col-md-4 col-lg-4 mt-2">
                <SelectBox
                  className="basic-multi-select"
                  styles={customStylesWithOutColor}

                  value={offenderAssaultID}
                  name='OffenderAssaultID'
                  options={offenderAssaultDrp}
                  isClearable={false}

                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={true}
                  components={{ MultiValue, }}
                  onChange={(e) => AssaultTypeChange(e)}
                  placeholder='Select Assault Type List'

                />
              </div>
              <div className="col-2 col-md-2 col-lg-2 mt-3">
                <span style={{ lineHeight: 1.1 }} data-toggle="modal" onClick={() => setOpenPage("Injury Type")} data-target="#ListModel" className="new-link  ">
                  Injury Type
                </span>
              </div>
              <div className="col-4 col-md-4 col-lg-4  mt-2 ">
                <SelectBox
                  className="basic-multi-select"

                  value={offenderInjuryID}
                  styles={customStylesWithOutColor}
                  name='OffenderInjuryID'
                  options={injuryTypeDrp}
                  isClearable={false}

                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={true}
                  components={{ MultiValue, }}
                  onChange={(e) => InjuryTypeChange(e)}
                  placeholder='Select Injury Type List'
                />
              </div>
            </div>
          </div>
          <div className="col-2 col-md-2 col-lg-2 mt-3">
            <label htmlFor="" className='new-label'>
              Property
            </label>
          </div>
          <div className="col-4 col-md-4 col-lg-4 mt-2">
            <SelectBox
              className="basic-multi-select"

              value={offenderPropertyID}
              name='OffenderPropertyID'
              options={propertyDrp}
              isClearable={false}

              isMulti

              closeMenuOnSelect={false}
              hideSelectedOptions={true}
              components={{ MultiValue, }}
              onChange={(e) => PropertyChange(e)}
              placeholder='Select Property List'
              styles={customStylesWithOutColor}
            />
          </div>

          {/* Offender Suspected Of Using */}

          <div className="col-2 col-md-2 col-lg-2 mt-3">
            <label htmlFor="" className='new-label'>
              Offender Suspected Of Using
            </label>
          </div>
          <div className="col-4 col-md-4 col-lg-4 mt-2">
            <SelectBox
              className="basic-multi-select"
              name='offenderusing'
              options={crimeOffenderUseDrp}
              isClearable={false}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={true}
              components={{ MultiValue, }}
              onChange={(e) => OffenderUsingChange(e)}
              value={offenderUsing}
              placeholder='Select Offender Using From List'
              styles={customStylesWithOutColor}
            />
          </div>

          {/* Bias Motivation */}
          <div className="col-2 col-md-2 col-lg-2 mt-3">
            <label htmlFor="" className='new-label'>
              Bias Motivation (Select Upto 5)
            </label>
          </div>
          <div className="col-4 col-md-4 col-lg-4 mt-2">
            <SelectBox
              className="basic-multi-select"
              name='bias'
              options={crimeBiasCategoryDrp}
              isClearable={false}
              isMulti
              closeMenuOnSelect={false}
              components={{ MultiValue, }}
              onChange={(e) => BiasMotivationChange(e)}
              value={biasMotivation}
              placeholder='Select Bias From List'
              styles={customStylesWithOutColor}
            />
          </div>

          {/* Weapon Used */}
          <div className="col-2 col-md-2 col-lg-2 mt-3">
            <label htmlFor="" className='new-label'>
              Weapon Used (Select Upto 3)
            </label>
          </div>
          <div className="col-4 col-md-4 col-lg-4 my-2">
            <SelectBox
              className="basic-multi-select"
              name='WeaponTypeID'
              isClearable={false}
              options={weaponDrp}
              hideSelectedOptions={true}
              closeMenuOnSelect={false}
              components={{ MultiValue, }}
              onChange={(e) => WeaponUsedChange(e)}
              value={weaponID}
              placeholder='Select Weapon Used From List'
              isMulti
              menuPlacement='top'
              styles={customStylesWithOutColor}
            />
          </div>
        </div>
      </div>
      <ListModal {...{ openPage, setOpenPage }} />
    </>
  )
}

export default Home